<!--
 * @Description: 
 * @Version: V1.0.0
 * @Author: 周艳凯 750419898@qq.com
 * @Date: 2024-01-22 17:24:38
 * @LastEditors: 周艳凯 750419898@qq.com
 * @LastEditTime: 2024-03-18 13:41:38
 * @FilePath: question.vue
 * Copyright 2024 Marvin, All Rights Reserved. 
 * 2024-01-22 17:24:38
-->
<template>
  <div>
    <div
      class="title"
      v-html="value.questionDescription || value.question.questionDescription"
    ></div>
    <div>
      <div
        v-model="value.isTrue"
        :is="
          value.question
            ? value.question.questionType == 2
              ? 'el-checkbox-group'
              : 'el-radio-group'
            : value.questionType == 2
            ? 'el-checkbox-group'
            : 'el-radio-group'
        "
      >
        <div
          class="question-answer"
          v-for="(item, index) in value.answerList"
          :key="item.answerId"
        >
          <div
            :label="item.questionAnswerId"
            :is="
              value.question
                ? value.question.questionType == 2
                  ? 'el-checkbox'
                  : 'el-radio'
                : value.questionType == 2
                ? 'el-checkbox'
                : 'el-radio'
            "
          >
            <span>{{ letter[index] }}.</span>
            <span v-html="item.questionAnswer"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "question",
  props: {
    value: Object,
    letter: String,
  },
  created() {},
};
</script>

<style scoped lang="scss">
.question-info {
  margin-left: 112px;
}

::v-deep .el-radio-group {
  width: 100%;
}
.title {
  font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  line-height: 22px;
  margin-bottom: 30px;
}

::v-deep .question-answer > .is-checked {
  border: 1px solid #264f99;
}

::v-deep .el-radio {
  display: flex;
  align-items: center;
  padding: 8px 20px;
  border: 1px solid #e0e0e0;
  border-radius: 3px;
  margin-bottom: 10px;
  .el-radio__label {
    font-size: 16px;
    white-space: pre-wrap;
    line-height: 24px;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #264f99;
  }
  .el-radio__input.is-checked .el-radio__inner {
    background: #264f99;
  }
}

::v-deep .el-checkbox {
  display: flex;
  align-items: center;
  padding: 8px 20px;
  border: 1px solid #e0e0e0;
  border-radius: 3px;
  margin-bottom: 10px;
  .el-checkbox__label {
    font-size: 16px;
    white-space: pre-wrap;
    line-height: 24px;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #264f99;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background: #264f99;
  }
}
</style>
